import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';

import { useNavbar } from './useNavbar';
import { NavbarNotification } from './NavbarNotification';
import { UserMenu } from './UserMenu';
import { LanguageMenu } from './LanguageMenu';

/**
 * Navbar reduzida para telas pré-tenant (ex.: seleção de conta): mantém só o menu
 * de idioma e o menu do usuário limitado ao logout. Sem seletor de conta (ainda não
 * há conta selecionada) e sem os itens que dependem de tenant/permissões — por isso
 * as flags de exibição do UserMenu vão todas como false (o logout nunca é filtrado).
 *
 * Reusa o mesmo view-model da Navbar completa (useNavbar): fora de tenant, os fetches
 * de pessoa/contas de integrador ficam desabilitados e só locales (endpoint público)
 * é buscado, então não há chamada tenant-scoped que redirecione a sessão.
 */
export function BrandedNavbar(): JSX.Element {
  const {
    personName,
    personPhoto,
    locales,
    notification,
    onLogout,
    onNavigate,
    onChangeLanguage,
    onDismissNotification,
  } = useNavbar();

  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      sx={{ backgroundColor: 'transparent', boxShadow: 'none', borderBottom: 'none' }}
    >
      <Toolbar sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
        <LanguageMenu locales={locales} onChangeLanguage={onChangeLanguage} />

        <Divider orientation="vertical" flexItem />

        <UserMenu
          personName={personName}
          personPhoto={personPhoto}
          showMyData={false}
          showSettings={false}
          showSelectAccount={false}
          showChangePassword={false}
          onNavigate={onNavigate}
          onLogout={onLogout}
        />
      </Toolbar>

      <NavbarNotification notification={notification} onDismiss={onDismissNotification} />
    </AppBar>
  );
}
